/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Teal_That_Bee_DigInputs */

const en_teal_that_bee_dig = /** @type {(inputs: Teal_That_Bee_DigInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add (${i?.count})`)
};

const de_teal_that_bee_dig = /** @type {(inputs: Teal_That_Bee_DigInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hinzufügen (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Add ({count})" |
*
* @param {Teal_That_Bee_DigInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teal_that_bee_dig = /** @type {((inputs: Teal_That_Bee_DigInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_That_Bee_DigInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_teal_that_bee_dig(inputs)
	return de_teal_that_bee_dig(inputs)
});